export function getRenewalEligibility(leaseStart, leaseEnd, settings) {
  if (!leaseEnd) return { eligible: false, daysRemaining: null, durationDays: null, threshold: null };

  const toLocalDay = (iso) => {
    if (!iso) return null;
    const s = typeof iso === 'string' ? iso.trim() : '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (m) {
      const d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
      d.setHours(0, 0, 0, 0);
      return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = toLocalDay(leaseEnd);
  if (!end) return { eligible: false, daysRemaining: null, durationDays: null, threshold: null };

  const start = toLocalDay(leaseStart);

  const MS_PER_DAY = 1000 * 60 * 60 * 24;
  const daysRemaining = Math.round((end - today) / MS_PER_DAY);
  if (daysRemaining < 0) {
    return { eligible: false, daysRemaining, durationDays: null, threshold: null, expired: true };
  }
  const durationDays = start ? Math.round((end - start) / MS_PER_DAY) : null;

  let threshold = 60;
  if (typeof settings === 'number') {
    threshold = settings;
  } else if (settings && typeof settings === 'object') {
    const t1 = settings.renewal_threshold_1m;
    const t3 = settings.renewal_threshold_3m;
    const t6 = settings.renewal_threshold_6m;
    const legacy = settings.renewal_threshold_days;
    if (durationDays != null) {
      if (durationDays <= 45 && t1 != null) threshold = t1;
      else if (durationDays <= 120 && t3 != null) threshold = t3;
      else if (t6 != null) threshold = t6;
      else if (legacy != null) threshold = legacy;
    } else if (legacy != null) {
      threshold = legacy;
    }
  }

  return { eligible: daysRemaining <= threshold, daysRemaining, durationDays, threshold, expired: false };
}
